// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"477":"d2190656","671":"356fbde1","831":"956969ba"}[chunkId] + ".chunk.css";
};